import { useTranslate } from '@tolgee/react';
import { Button, Spinner } from 'react-bootstrap';

import { POST_STATUS_COCKPIT_TEMPLATE } from '../../config/constants';

export const isCockpitTemplateEditor = (lomavisCreator: any): boolean =>
  lomavisCreator.post_status === POST_STATUS_COCKPIT_TEMPLATE &&
  Boolean(lomavisCreator.lomavisCreatorConfig?.is_update);

export const getCreatorActionPostStatus = (lomavisCreator: any) =>
  lomavisCreator?.lomavisCreatorConfig?.importing_post
    ? null
    : lomavisCreator.post_status;

type CockpitTemplateActionsProps = {
  footerRef: React.RefObject<HTMLDivElement>;
  importPostUrl?: string;
  isSaving: boolean;
  onSave: () => Promise<void>;
  rightMargin: number;
};

export const CockpitTemplateActions = ({
  footerRef,
  importPostUrl,
  isSaving,
  onSave,
  rightMargin
}: CockpitTemplateActionsProps) => {
  const { t } = useTranslate();
  const useTemplateDisabled = isSaving || !importPostUrl;

  return (
    <div className="d-flex p-2 w-100" ref={footerRef}>
      <div
        className="d-flex align-items-center gap-2 ms-auto"
        style={{ marginRight: rightMargin }}
      >
        <a
          role="link"
          className={`btn btn-success btn-sm ${
            useTemplateDisabled ? 'disabled' : ''
          }`}
          href={useTemplateDisabled ? undefined : importPostUrl}
          aria-disabled={useTemplateDisabled}
          tabIndex={useTemplateDisabled ? -1 : undefined}
        >
          {t('lomavisCreator.buttonsBar.use_post_template')}
        </a>
        <Button
          variant="primary"
          size="sm"
          disabled={isSaving}
          onClick={() => {
            void onSave();
          }}
        >
          {isSaving && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-1"
            />
          )}
          {t(
            isSaving
              ? 'lomavisCreator.buttonsBar.saving'
              : 'lomavisCreator.buttonsBar.save'
          )}
        </Button>
      </div>
    </div>
  );
};
